import { render, staticRenderFns } from "./Time4EvolucaoSupervisor.vue?vue&type=template&id=1f6a57b5&scoped=true&"
import script from "./Time4EvolucaoSupervisor.vue?vue&type=script&lang=js&"
export * from "./Time4EvolucaoSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./Time4EvolucaoSupervisor.vue?vue&type=style&index=0&id=1f6a57b5&scoped=true&lang=css&"
import style1 from "./Time4EvolucaoSupervisor.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a57b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VChip,VContainer,VIcon,VRadio,VRadioGroup})
